
import { Observer } from 'mobx-vue'
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Throttle, Bind } from 'lodash-decorators'

@Observer
@Component({
  components: {}
})
export default class MyLayout extends Vue {
  @Prop({ default: () => [] }) menuList: Array<{
    label: string
    value: string
  }>
  @Prop({ required: true }) menuKey: string

  @Prop({ default: false }) customRightContent: boolean

  @Prop({ default: false }) hasFilter: boolean

  isScrolled: boolean = false

  @Throttle(100, { leading: true, trailing: true })
  @Bind()
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

    if (scrollTop > 0) {
      if (!this.isScrolled) {
        this.isScrolled = true
      }
    } else {
      this.isScrolled = false
    }
  }

  created(): void {}

  mounted(): void {
    window.addEventListener('scroll', this.onScroll)
  }

  updated(): void {}

  destroyed(): void {
    window.removeEventListener('scroll', this.onScroll)
  }
}
